import { app } from '../app.module'
/**
 * イベントデータに関するService
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function EventCommon() {
  /**
   * イベントをフィルタリングする
   * @param  [Array] events イベントデータ
   * @param  {number} monthValue 選択月
   * @param  {string} keyword 検索キーワード
   * @return [Array] フィルタリングされたイベントデータ
   */
  function filterEvents(events, monthValue: number, keyword: string) {
    let filterdEvents = events

    // 月が選択されている場合は、月でフィルタリングする
    if (monthValue !== null && monthValue !== undefined) {
      filterdEvents = filterdEvents.filter((event) => {
        return Number(event.month) === Number(monthValue)
      })
    }

    // キーワードが選択されている場合は、イベント名と説明文をキーワードでフィルタリングする
    if (keyword !== null && keyword !== undefined) {
      filterdEvents = filterdEvents.filter((event) => {
        if (event.eventName.indexOf(keyword) !== -1 || event.description.indexOf(keyword) !== -1) {
          return true
        }
      })
    }

    return filterdEvents
  }

  /**
   * viewmに表示する用の日付を出力する
   * @param  {number} eventDate イベント日付
   */
  function addDisplayDate(eventDate: number) {
    const early = 97
    const mid = 98
    const late = 99
    // 日付が31日以下の場合は'日'をつけて出力する
    if (eventDate <= 31) {
      return eventDate + '日'
    }
    // 指定した日付のデータが入っている場合は、上旬、中旬、下旬で返す
    if (eventDate === early) {
      return '上旬'
    }
    if (eventDate === mid) {
      return '中旬'
    }
    if (eventDate === late) {
      return '下旬'
    }
  }

  return {
    filterEvents: filterEvents,
    addDisplayDate: addDisplayDate,
  }
}

/**
 * EventService イベント関連のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} EventCommon イベントデータに関するService
 * @return {Object} サービスのオブジェクト
 */
function EventService(EventCommon) {
  return {
    Common: EventCommon,
  }
}

// サービスを定義
app.factory('EventService', EventService).factory('EventCommon', EventCommon)
